var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-youtube" }, [
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(_vm._s(_vm.$t("dash.post-creator.form.youtube.visibility"))),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c(
            "div",
            { staticClass: "content-detail" },
            [
              _c("SelectComponent", {
                attrs: {
                  valueSelect:
                    _vm.draftInstance.form.networks.youtube.visibility,
                  changeValueSelect: _vm.changeVisibilityPost,
                  data: {
                    public: _vm.$t(
                      "dash.post-creator.form.youtube.visibility-public"
                    ),
                    private: _vm.$t(
                      "dash.post-creator.form.youtube.visibility-private"
                    ),
                    unlisted: _vm.$t(
                      "dash.post-creator.form.youtube.visibility-unlisted"
                    ),
                  },
                  positionAuto: false,
                  positionX: "left",
                },
              }),
              _c(
                "div",
                { staticClass: "type-switch" },
                [
                  _vm._v(
                    "\n                  " +
                      _vm._s(
                        _vm.$t(
                          "dash.post-creator.form.youtube.notify-subscribers"
                        )
                      ) +
                      "\n                 "
                  ),
                  _c("ComponentSwitch", {
                    attrs: {
                      value:
                        _vm.draftInstance.form.networks.youtube
                          .notifySubscribers,
                      onChange: (v) =>
                        (_vm.draftInstance.form.networks.youtube.notifySubscribers =
                          v),
                      id: "switch-settings-advanced-youtube-1",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "type-switch" },
                [
                  _vm._v(
                    "\n                  " +
                      _vm._s(
                        _vm.$t(
                          "dash.post-creator.form.youtube.children-content"
                        )
                      ) +
                      "\n                 "
                  ),
                  _c("ComponentSwitch", {
                    attrs: {
                      value:
                        _vm.draftInstance.form.networks.youtube
                          .contentForChildren,
                      onChange: (v) => {
                        _vm.draftInstance.form.networks.youtube.contentForChildren =
                          v
                      },
                      id: "switch-settings-advanced-youtube-2",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(_vm._s(_vm.$t("dash.post-creator.form.youtube.category"))),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c(
            "div",
            { staticClass: "content-detail" },
            [
              _c("SelectComponent", {
                attrs: {
                  valueSelect:
                    _vm.draftInstance.form.networks.youtube.category || "22",
                  changeValueSelect: _vm.selectCategory,
                  data: this.$store.getters["postCreator/youtubeCategories"]
                    .length
                    ? Object.fromEntries(
                        this.$store.getters[
                          "postCreator/youtubeCategories"
                        ].map((category) => [
                          category.id.toString(),
                          category.snippet.title,
                        ])
                      )
                    : { 22: "People & Blogs" },
                  positionAuto: false,
                  positionX: "left",
                },
              }),
            ],
            1
          ),
        ]),
        _c("details", { attrs: { open: "" } }, [
          _vm._m(0),
          _c("div", { staticClass: "content-detail content-detail-tag" }, [
            _vm.draftInstance.form.networks.youtube.tags.length
              ? _c(
                  "div",
                  { staticClass: "list-tags" },
                  _vm._l(
                    _vm.draftInstance.form.networks.youtube.tags,
                    function (tag, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "tag",
                          on: { click: () => _vm.removeTag(tag) },
                        },
                        [
                          _vm._v(_vm._s(tag) + " "),
                          _c("i", { staticClass: "fa-solid fa-circle-xmark" }),
                        ]
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
            _c("div", { staticClass: "type-input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputModel.tag,
                    expression: "inputModel.tag",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t("dash.post-creator.form.youtube.add-tag"),
                },
                domProps: { value: _vm.inputModel.tag },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return (() => _vm.addTag()).apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.inputModel, "tag", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(_vm._s(_vm.$t("dash.post-creator.form.youtube.playlist"))),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail" }, [
            _c(
              "div",
              { staticClass: "selects" },
              [
                _c("SelectComponent", {
                  attrs: {
                    valueSelect: _vm.pageSelectedSelectPlayList,
                    changeValueSelect: (v) =>
                      (_vm.inputModel.pageSelectForSelectPlaylist = v),
                    data: _vm.pageYoutubeSelected.length
                      ? {
                          ...Object.fromEntries(
                            _vm.pageYoutubeSelected.map((p) => [p.id, p.name])
                          ),
                        }
                      : {},
                    positionAuto: false,
                    positionX: "left",
                  },
                }),
                _c("SelectComponent", {
                  attrs: {
                    valueSelect: _vm.valueSelectPlayList,
                    changeValueSelect: _vm.selectPlaylist,
                    data: _vm.listPlaylistForSelect,
                    positionAuto: false,
                    positionX: "left",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("summary", [
      _vm._v("Tags"),
      _c("i", { staticClass: "fa-solid fa-caret-down" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }